import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin: 0.5em 0;
  position: relative;
  display: ${props => (props.isHorizontal ? 'flex' : 'block')};
  flex-direction: ${props => (props.isHorizontal ? 'row' : 'unset')};
  align-items: ${props => (props.isHorizontal ? 'center' : 'unset')};
  gap: ${props => (props.isHorizontal ? '10px' : 'unset')};
`;

export const InputTitle = styled.div`
  margin-top: 20px;
  color: #4b286d;
  font-size: 1.2rem;
  font-weight: 700;
`;

// Renders no box of its own (display: contents) and makes the wrapped UDS
// field label render slightly bolder. The descendant selector is needed because
// the UDS Typography element sets its own font-weight via its generated class,
// which overrides plain inheritance.
//
// Cross-OS note: the global Helvetica reset (style.css) strips labels onto
// OS-local fonts. `font-weight: 500` then diverges by platform — macOS Helvetica
// Neue ships a real Medium (500) face so it looks bold, but Windows falls back to
// Arial (only 400/700), where 500 rounds down to 400 and renders light. Pinning
// the label to the TELUS Medium webfont `HNforTELUSSA500normal` (loaded via
// uds-fonts.css, with the weight baked into the face) makes it render identically
// on every OS. The Helvetica/Arial stack is kept only as a webfont-load fallback.
export const BoldFieldLabel = styled.div`
  display: contents;
  /* With display: contents the heading becomes the flex item of the field's
     inline-flex label row; react-native-web gives it flex-shrink: 0, so a long
     label would never wrap and overflow the form. */
  && > * {
    flex-shrink: 1;
    min-width: 0;
    max-width: 100%;
  }
  & div {
    min-width: 0;
    max-width: 100%;
    white-space: pre-line;
    overflow-wrap: anywhere;
    font-family: 'HNforTELUSSA500normal', 'Helvetica Now', 'Helvetica Neue',
      Helvetica, Arial, sans-serif !important;
    font-weight: 500 !important;
    ${({ labelColor }) => labelColor && `color: ${labelColor} !important;`}
  }
`;

export const FieldWrapper = styled.div`
  margin: 0.5em 0;
`;

export const CheckboxFieldWrapper = styled.div`
  margin: 0.5em 0;
`;

export const Button = styled.button`
  margin: 0.5em 0;
  border: 0;
`;

export const FieldRowOuterWrapper = styled.div`
  display: flex;
  align-items: stretch;
  margin-top: -1px;
`;

export const FieldRowWrapper = styled.div`
  background-color: #efefef;
  border: solid 1px;
  border-color: #e2e2e2;
  padding: 10px;
  max-width: max-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledLabelWrapper = styled.div`
  flex-shrink: 0;
  text-align: center;
  padding: 10px;
  box-shadow: 0 0 6px #aaa;
  width: 280px;
  margin-right: 1em;
`;

export const PlusMinusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const PlusMinusDropdownBlock = styled.div`
  display: flex;
  align-items: center;
  background-color: #efefef;
  border: solid 1px #e2e2e2;
  border-left: none;
  padding: 10px;
`;

export const PlusMinusDropdownSelect = styled.select`
  height: 36px;
  min-width: 160px;
  font-size: 13px;
  font-family: inherit;
  padding: 0 8px;
  cursor: pointer;
  appearance: auto;
  background-color: #ffffff;
  border: 1px solid #e2e2e2;
  border-radius: 2px;
`;
export const ToolTipWrapper = styled.div`
  margin: 0rem 0 0 0.25rem;
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-top: 1rem;
`;

export const TableWrapper = styled.div`
  border: 1px solid #9a9a9a;
  width: 50%;
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  padding: 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;
